import { validationRules } from "../../utils/validation"
// import { useLocation } from "react-router-dom"



export const UBOTypeSelectSchema = {
    

    ubos: [
        validationRules.atLeastOneValueNotEmpty("Select at least one UBO type"),
    ]
}

export const UBOTypeSchema = {
    type: [
        validationRules.required("Select UBO Type"),
    ]
}

export const UBOPrivateIndividualSchema = {
    ubofullName: [
        validationRules.required("Full Name is required"),
    ],
    uboNationality: [
        validationRules.required("Nationality is required"),
    ],

    // uboContactDetails: [
    //     validationRules.required("Contact Detail is required"),
    // ],
    ubodateOfBirth: [
        validationRules.required("Date of Birth is required"),
    ],
    uboaddressLine1: [
        validationRules.required("Residential Address 1 is required"),
    ],
    // ubostate: [
    //     validationRules.required("State is required"),
    // ],
    ubopostalCode: [
        validationRules.required("Postal code is required"),
    ],
    ubocountry: [
        validationRules.required("Country is required"),
    ],

    ubosoleDirector: [
        validationRules.required("Is this person sole director for the entity required"),
    ],
    uboMet: [
        validationRules.required("Have you met this individual face to face? is required"),
    ]
}

export const UBOPrivateCompanySchema = {
    uboCompanyName: [
        validationRules.required("Company Name is required"),
    ],
    uboCountry: [
        validationRules.required("Country of Incorporation is required"),
    ],
    uboCompanyType: [
        validationRules.required("Company Type is required"),
    ],
    uboCompanyRegistrationNumber: [
        validationRules.required("Company Registration Number is required"),
    ],
    uboRegisteredOfficeAddress: [
        validationRules.required("Registered Office Address is required"),
    ],
    uboRegulatory: [
        validationRules.required("Is this entity regulated by a recognised regulatory body? is required"),
    ],
}

export const UBOPrivateCompanyRegulatoryYesSchema = {
    uboRegulatoryBody: [
        validationRules.required("Select Regulatory Body is required"),
    ],
}

export const UBOPartnershipSchema = {
    uboPartnershipName: [
        validationRules.required("Partnership Name is required"),
    ],
    uboCountry: [
        validationRules.required("Country of Incorporation is required"),
    ],
    uboPartnershipType: [
        validationRules.required("Partnership Type is required"),
    ],
    uboRegistrationNumber: [
        validationRules.required("Registration Number is required"),
    ],
    uboBusinessAddress: [
        validationRules.required("Registered Office Address is required"),
    ],
    uboPartners: [
        validationRules.atLeastOneValueNotEmpty("Partners is required"),
    ],
    uboRegulatory: [
        validationRules.required("Is this entity regulated by a recognised regulatory body? is required"),
    ]
}

export const UBOPartnershipRegulatoryYesSchema = {
    uboRegulatoryBody: [
        validationRules.required("Select Regulatory Body is required"),
    ],
}

export const UBOStockExchangeSchema = {
    uboEntityName: [
        validationRules.required("Entity Name is required"),
    ],
    uboCountry: [
        validationRules.required("Country of Incorporation is required"),
    ], 
    uboCompanyRegistrationNumber: [
        validationRules.required("Company Registration Number is required"),
    ],
    uboRegisteredOfficeAddress: [
        (formData) =>
            formData.uboRegisteredOfficeAddress || formData.uboRegistrationNumber
                ? null
                : "Registered Office Address is required"
    ]
}

// Exchange name is only required when the entity is actually listed.
export const UBOStockExchangeRecognisedYesSchema = {
    uboRecognisedExchangeBodies: [
        validationRules.required("Select Exchange is required"),
    ],
}

export const UBORegulatedEntitySchema = {
    uboEntityName: [
        validationRules.required("Entity Name is required"),
    ],
    uboCountry: [
        validationRules.required("Country of Incorporation is required"),
    ],
    uboEntityType: [
        validationRules.required("Type of Entity is required"),
    ],
    uboRegulatoryBody: [
        validationRules.required("Regulatory Body is required"),
    ],
    uboRegulatoryReferenceNumber: [
        validationRules.required("Regulatory Reference Number is required"),
    ]
}

export const UBOPensionFundSchema = {
    uboPensionFundName: [
        validationRules.required("Pension Fund Name is required")
    ],
    uboRegisteredAddress: [
        validationRules.required("Registered Address is required")
    ],
    uboIsPensionFundRegistered: [
        validationRules.required("Is the Pension Fund registered with the Pensions Regulator? is required")
    ],
    uboIsPensionFundRegisteredWithHMRC: [
        validationRules.required("Is the Pension Fund registered with HMRC? is required")
    ],
    uboRegulatoryReferenceNumber: [
        validationRules.required("Regulatory Reference Number is required")
    ]
}

export const UBOTrustSchema = {
    uboTrustName: [
        validationRules.required("Trust Name is required")
    ],
    uboTrustType: [
        validationRules.required("Trust Type is required")
    ],
    // uboSettlorName: [
    //     validationRules.required("Name of Settlor is required")
    // ],
    uboSettlorType: [
        validationRules.required("Settlor Type is required")
    ],
    uboCorporateSettlorName: [
    (formData) =>
      formData.uboSettlorType === "Corporate Entity"
        ? validationRules.required("Corporate Settlor Name is required")
        : null
  ],
  uboIndividualSettlorType: [
    (formData) =>
      formData.uboSettlorType === "Private Individual" 
      
        ? validationRules.required("Settlor Deceased or Not is required")
        : null
  ],


    uboIndividualSettlorName: [
    (formData) =>
      formData.uboSettlorType === "Private Individual" &&
      formData.uboIndividualSettlorType === "No"
        ? validationRules.required("Individual Settlor Name is required")
        : null
  ],
   
    
    uboTrustPurpose: [
        validationRules.required("Purpose of Trust is required")
    ],
    uboTrustProtectorOrController: [
        validationRules.required("Is there a Protector or Controller? is required")
    ],
    uboTrusteeType: [
        validationRules.required("Trustee Type is required")
    ],
    uboTrustDeedObtained: [
        validationRules.required("Please indicate if you have obtained a copy of the trust deed")
    ],
}

export const UBOTrustDeedNotObtainedSchema = {
    uboTrustDeedNotObtainedReason: [
        validationRules.required("Please explain why you have been unable to obtain a copy of the Trust deed")
    ]
}

export const UBOTrustTypeBeneficiarySchema = {
    uboTrustFullNameOfBeneficiaries: [
        validationRules.atLeastOneValueNotEmpty("Full Name of Beneficiaries is required")
    ]
}

export const UBOTrustClassOfBeneficiariesSchema = {
    uboTrustClassOfBeneficiaries: [
        validationRules.atLeastOneValueNotEmpty("Class of Beneficiaries is required")
    ]
}

export const UBOTrustProtectorOrControllerYesSchema = {
    uboProtectorOrControllerName: [
        validationRules.required("Name of Protector or Controller is required")
    ]
}

export const UBOTrustCorporateTrusteeSchema = {
    uboCorporateTrusteeName: [
        validationRules.required("Trustee Name is required")
    ],
    uboCorporateTrusteeCountryOfIncorporation: [
        validationRules.required("Country of Incorporation is required")
    ],
    uboCorporateTrusteeRegistrationNumber: [
        validationRules.required("Registration Number is required")
    ],
    uboCoporateTrusteeRegulatedTrustCompany: [
        validationRules.required("Regulated Trust Company? is required")
    ]
}

export const UBOTrustLegalPersonSchema = {
    uboLegalPersonCompanyName: [
        validationRules.required("Company Name is required")
    ],
    uboLegalPersonCountryOfIncorporation: [
        validationRules.required("Country of Incorporation is required")
    ],
    uboLegalPersonCompanyType: [
        validationRules.required("Company Type is required")
    ],
    uboLegalPersonCompanyRegistrationNumber: [
        validationRules.required("Company Registration Number is required")
    ],
    uboLegalPersonRegisteredOfficeAddress: [
        validationRules.required("Registered Office Address is required")
    ],
    uboLegalPersonDirectors: [
        validationRules.atLeastOneValueNotEmpty("Name of Directors is required")
    ]
}

export const UBOTrustNaturalPersonSchema = {
    uboNaturalPersonName: [
        validationRules.required("Name of Trustee is required")
    ],
    uboNaturalPersonNationality: [
        validationRules.required("Nationality is required")
    ]
}

export const UBOUnitTrustSchema = {
    uboUnitTrustName: [
        validationRules.required("Name of Unit Trust is required")
    ],
    uboSettlorName: [
        validationRules.required("Name of Settlor is required")
    ],
    uboTrustPurpose: [
        validationRules.required("Purpose of Trust is required")
    ],
    uboChannelIslandState: [
        validationRules.required("Channel Island State is required")
    ],
    uboProtectorOrControllerName: [
        validationRules.required("Name of Protector or Controller is required")
    ],
    uboCountryOfEstablishment: [
        validationRules.required("Country of Establishment is required")
    ],
    uboUnitTrustManager: [
        validationRules.required("Name of Unit Trust Manager/ Trust Company is required")
    ],
    uboNominees: [
        (formData) => {
            const nominees = formData.uboNominees;
            if (!Array.isArray(nominees) || nominees.length === 0) {
                return "At least one Nominee Company is required";
            }
            const incomplete = nominees.some(
                (n) =>
                    !n?.name?.trim() ||
                    !n?.country?.trim() ||
                    !n?.companyNumber?.trim() ||
                    !n?.registeredOffice?.trim()
            );
            if (incomplete) {
                return "Each Nominee Company must have a Name, Country of Establishment, Company Number and Registered Office";
            }
            return null;
        }
    ],
    uboTrustees: [
        (formData) => {
            const trustees = formData.uboTrustees;
            if (!Array.isArray(trustees) || trustees.length === 0) {
                return "At least one Trustee is required";
            }
            const incomplete = trustees.some((t) => !t?.name?.trim() || !t?.registeredOffice?.trim() || !t?.companyNumber?.trim());
            if (incomplete) {
                return "Each Trustee must have a Name, Registered Office and Company Number";
            }
            return null;
        }
    ],
    uboHasUnitHolder: [
        validationRules.required("Is there a +25% Unit Holder? is required")
    ],
    uboUnitHolderNames: [
        (formData) =>
            formData.uboHasUnitHolder === "Yes"
                ? validationRules.atLeastOneValueNotEmpty("Identify at least one +25% Unit Holder")
                : null
    ]
}

export const UBOFundSchema = {
    uboFundName: [
        validationRules.required("Fund Name is required")
    ],
    uboRegulatedFund: [
        validationRules.required("Is this a regulated fund? is required")
    ],
    uboFundType: [
        validationRules.required("Type of Fund is required")
    ],
    uboNature: [
        validationRules.required("Nature/Purpose is required")
    ],
    uboCountry: [
        validationRules.required("Country of Registration is required")
    ],
    uboFundManager: [
        validationRules.required("Name of Fund Manager is required")
    ],
    uboIsRegulatedFundManager: [
        validationRules.required("Is the fund manager regulated? is required")
    ],
    uboAreThereAnyInvestors: [
        validationRules.required("Are there any +25% investors/ ultimate shareholders in the fund ? is required")
    ]
}

export const UBOFundRegulatedFundYesSchema = {
    uboRegulatoryReferenceNumber: [
        validationRules.required("Regulatory Reference Number is required")
    ]
}

export const UBOFundIsRegulatedFundManagerYesSchema = {
    uboRegulatoryBody: [
        validationRules.required("Name of Regulatory Body is required")
    ],
    uboRegulatoryReferenceNumber: [
        validationRules.required("Enter Regulatory Reference Number is required")
    ]
}

export const UBOPublicSectorSchema = {
    uboGovernmentLocalName: [
        validationRules.required("Full Name of Government/Local Authority is required")
    ],
    uboCountry: [
        validationRules.required("Country of Government or Local Authority")
    ],
    uboDescription: [
        validationRules.required("Government or Authority Description is required")
    ],
    uboContactName: [
        validationRules.required("Name of Contact/Representative is required")
    ]
}

export const UBOFoundationsSchema = {
    uboFoundationName: [
        validationRules.required("Name of Foundations is required"),
    ],
    uboPrincipleAdministrator: [
        validationRules.required("Principle Administrator / Trustee is required"),
    ],
    uboIsRegulated: [
        validationRules.required("Is the Principal Administrator/ Trustee Regulated? is required"),
    ],
    uboCountry: [
        validationRules.required("Country of Establishment is required"),
    ],
    uboFounderIdentity: [
        validationRules.required("Identity of the Founder is required"),
    ],
    uboStatedPurpose: [
        validationRules.required("Stated purpose of the foundation is required"),
    ],
    uboActivities: [
        validationRules.required("Nature of activities is required"),
    ],
    uboCategory: [
        validationRules.required("Category of Beneficiaries is required"),
    ],
    uboClass: [
        validationRules.required("Class of Beneficiaries is required")
    ],
    uboBoardMembers: [
        validationRules.required("Name and identity of board members/directors")
    ]
}

export const UBOFoundationsIsRegulatedYesSchema = {
    uboRegulatoryBody: [
        validationRules.required("Name of Regulatory Body is required"),
    ]
}

export const UBOSovereignWealthFundsSchema = {
    uboSovereignWealthFundName: [
        validationRules.required("Full Name of Sovereign Wealth Fund is required"),
    ],
    uboNationalGovernment: [
        validationRules.required("Name of National Government is required"),
    ],
    uboNature: [
        validationRules.required("Nature/Purpose is required"),
    ],
    uboSeniorManager: [
        validationRules.required("Name of Senior Manager is required"),
    ],
    uboIsMember: [
        validationRules.required("Is the Sovereign Wealth Fund a member of the International Working Group? is required"),
    ]
}

export const UBOChruchBodiesSchema = {
    uboFullName: [
        validationRules.required("Full Name is required"),
    ],
    uboAddress: [
        validationRules.required("Address is required"),
    ],
    uboNature: [
        validationRules.required("Nature/Purpose is required"),
    ],
    uboClasses: [
        validationRules.required("Names of Classes of Beneficiaries")
    ],
    uboChairman: [
        validationRules.required("Chairman of the Board of Trustees")
    ]
}

export const UBOCharitiesSchema = {
    uboCharityName: [
        validationRules.required("Full Name is required"),
    ],
    uboCharityNumber: [
        validationRules.required("Charity Number is required"),
    ],
    uboCharityAddress: [
        validationRules.required("Address is required"),
    ],
    uboCharityPurpose: [
        validationRules.required("Nature/Purpose of Charity is required"),
    ],
    uboCharityTrustees: [
        validationRules.required("Name(s) of Trustee(s) is required"),
    ],
    uboCharityBeneficiaries: [
        validationRules.required("Names of Beneficiaries is required")
    ],
    uboCharityBeneficiaryClass: [
        validationRules.required("Class of Beneficiaries is required")
    ]
}